/**
 * Auth Utility
 * =============
 * Uses the same localStorage key format as the ERP:
 *   Token key: {SCHOOLID}Authoritytoken  (e.g., GGV111Authoritytoken)
 *   User key:  {SCHOOLID}Authorityuser
 *
 * This ensures no re-login is needed if user is already logged in via ERP.
 */

export const getTokenKey = (schoolId) => `${schoolId.toUpperCase()}Authoritytoken`;
export const getUserKey = (schoolId) => `${schoolId.toUpperCase()}Authorityuser`;

export const getToken = (schoolId) => localStorage.getItem(getTokenKey(schoolId));

export const getUser = (schoolId) => {
  const stored = localStorage.getItem(getUserKey(schoolId));
  return stored ? JSON.parse(stored) : null;
};

export const setAuth = (schoolId, token, user) => {
  localStorage.setItem(getTokenKey(schoolId), token);
  localStorage.setItem(getUserKey(schoolId), JSON.stringify(user));
};

export const clearAuth = (schoolId) => {
  localStorage.removeItem(getTokenKey(schoolId));
  localStorage.removeItem(getUserKey(schoolId));
};

/**
 * Try to find a valid token from any schoolId key in localStorage.
 * Useful when schoolId is not yet known (e.g., landing on login page).
 */
export const findExistingAuth = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.endsWith('Authoritytoken')) {
      const schoolId = key.replace('Authoritytoken', '');
      const token = localStorage.getItem(key);
      const user = getUser(schoolId);
      if (token && user) {
        return { schoolId, token, user };
      }
    }
  }
  return null;
};
